// extracted by mini-css-extract-plugin
module.exports = {"mb-63":"AdviceExplorer_mb-63__XDt57"};